/* THE FIT SOCIETY — v40 : le code de soutien ne peut plus figer la page.

   Le problème : dans tfs-society.js, le bouton « Valider » fait
       apply.disabled = true;
       validate(code).then(...)   →  fetch() vers une fonction Supabase
   sans AUCUN délai maximum. Si Supabase est lent, en démarrage à froid, ou
   injoignable, la promesse ne se résout jamais : le bouton reste désactivé,
   aucun message n'apparaît, la page semble figée. C'est exactement le
   symptôme décrit.

   Ce script reprend la main sur le clic en phase de CAPTURE (donc avant le
   gestionnaire de tfs-society.js, qu'il neutralise) et applique trois règles :

     1. Délai maximum de 6 secondes sur la validation.
     2. Si la validation ne répond pas à temps, le code est appliqué QUAND
        MÊME au panier — l'attribution est réconciliée côté serveur plus
        tard. Un drop ne s'arrête pas parce qu'un service tiers est lent.
     3. Le bouton est TOUJOURS réactivé, quoi qu'il arrive.

   Seul un code explicitement rejeté par le validateur affiche une erreur. */
(function () {
  'use strict';

  var ENDPOINT = 'https://buzppaxdjkjmozzhxxqb.supabase.co/functions/v1/society-click';
  var TIMEOUT = 6000;

  function clean(c) {
    return String(c || '').toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 24);
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'tfs-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 500);
    }, 3600);
  }

  /* Validation bornée dans le temps. Trois issues possibles :
     true = code valide · false = code rejeté · null = pas de réponse */
  function validate(code) {
    return new Promise(function (resolve) {
      var done = false;
      var finish = function (val) { if (!done) { done = true; resolve(val); } };

      var ctrl = null;
      try { ctrl = new AbortController(); } catch (e) {}

      var timer = setTimeout(function () {
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        finish(null);
      }, TIMEOUT);

      var opts = { headers: { Accept: 'application/json' } };
      if (ctrl) opts.signal = ctrl.signal;

      fetch(ENDPOINT + '?code=' + encodeURIComponent(code), opts)
        .then(function (r) { return r.json(); })
        .then(function (v) { clearTimeout(timer); finish(v && v.valid === true); })
        .catch(function () { clearTimeout(timer); finish(null); });
    });
  }

  function setAttrs(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  /* Rendu de l'état « appliqué », avec ses propres gestionnaires. */
  function renderApplied(slot, code) {
    slot.innerHTML =
      '<p class="tfs-support__applied">Vous soutenez <strong>' + code + '</strong> ' +
      '<span aria-hidden="true">✓</span> ' +
      '<button type="button" class="tfs-support__edit" data-tfs-v40-remove>Retirer</button></p>';

    var rm = slot.querySelector('[data-tfs-v40-remove]');
    if (rm) {
      rm.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        rm.disabled = true;
        setAttrs({ support_code: '', support_source: '', support_landing: '', support_ts: '' })
          .catch(function () {})
          .then(function () {
            try { localStorage.removeItem('tfs_support'); } catch (err) {}
            window.location.reload();
          });
      });
    }
  }

  function handleApply(btn) {
    var slot = btn.closest('[data-tfs-support]');
    if (!slot) return;

    var input = slot.querySelector('[data-tfs-input]');
    var err = slot.querySelector('[data-tfs-error]');
    var code = clean(input ? input.value : '');

    if (err) err.hidden = true;

    if (!code) {
      if (err) { err.textContent = 'Entre un code pour continuer.'; err.hidden = false; }
      if (input) input.focus();
      return;
    }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Validation…';

    /* Filet de sécurité absolu : quoi qu'il arrive, le bouton revient. */
    var release = setTimeout(function () {
      btn.disabled = false;
      btn.textContent = label;
    }, TIMEOUT + 3000);

    validate(code).then(function (valid) {
      if (valid === false) {
        clearTimeout(release);
        btn.disabled = false;
        btn.textContent = label;
        if (err) { err.textContent = 'Ce code est introuvable ou inactif.'; err.hidden = false; }
        if (input) input.setAttribute('aria-invalid', 'true');
        return;
      }

      /* valid === true  → code confirmé
         valid === null  → validateur injoignable, on applique quand même */
      setAttrs({ support_code: code, support_source: 'manual' })
        .catch(function () { return null; })
        .then(function () {
          clearTimeout(release);
          btn.disabled = false;
          btn.textContent = label;
          try { localStorage.setItem('tfs_support', JSON.stringify({ code: code, ts: Date.now() })); } catch (e) {}
          renderApplied(slot, code);
          toast(valid === true
            ? 'Vous soutenez ' + code + ' ✓'
            : 'Code ' + code + ' enregistré ✓');
        });
    });
  }

  /* Phase de capture : on intercepte AVANT le gestionnaire de tfs-society.js. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-tfs-apply]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handleApply(btn);
  }, true);

  /* ─────────────────────────────────────────────────────────────
     Le panier de l'en-tête mène à la VRAIE page panier, plus au tiroir.

     On intercepte le clic en phase de CAPTURE : le gestionnaire de
     theme.js, qui ouvre le tiroir, n'est jamais atteint. On navigue
     nous-mêmes vers /cart. Le markup du header n'est pas touché —
     aucun risque de casser la liaison de theme.js.
     ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-cart-open]') : null;
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.location.href = el.getAttribute('href') || '/cart';
  }, true);

  /* Le bouton n'ouvre plus une boîte de dialogue : on corrige ce qu'il
     annonce aux lecteurs d'écran, sinon il ment sur son rôle. */
  function relabelCartButtons() {
    var els = document.querySelectorAll('[data-cart-open]');
    for (var i = 0; i < els.length; i++) {
      els[i].removeAttribute('aria-expanded');
      els[i].removeAttribute('aria-controls');
      els[i].setAttribute('aria-label', 'Voir mon panier');
      els[i].setAttribute('title', 'Voir mon panier');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelCartButtons);
  } else {
    relabelCartButtons();
  }

  /* Entrée clavier dans le champ = même chemin. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-tfs-input')) return;
    var slot = input.closest('[data-tfs-support]');
    var btn = slot ? slot.querySelector('[data-tfs-apply]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handleApply(btn);
  }, true);
})();
